import React, { useState } from "react";
import styled from "styled-components";
import TagQuery from "components/pages/tag/TagQuery";
import { FooterWithState } from "components/Footer";
import StoriesListLoader from "components/shared/spinners/StoriesListLoader";
import { useRouter } from "next/router";
import PageContainer from "components/containers/PageContainer";
import withApollo from "components/higher-order/withApollo";
import { useRecordPageView } from "hooks/analytics/useRecordPageView";
import { StoryList } from "components/shared/StoryList";
import { baseUrl } from "services/shared/Environment";
import StoriesListContainer from "components/shared/containers/StoriesListContainer";
import TagStoriesQuery from "components/pages/tag/TagStoriesQuery";
import ApiTag from "models/data/api/ApiTag";
import { NextSeo } from "next-seo";

const Title = styled.h1`
  font-family: ${(props) => props.theme.fonts.poppins};
`;

const TagPageContainer = styled.div`
  min-height: 100vh;
`;

function TagPage() {
  const {
    query: { slug: routerSlug },
    asPath,
  } = useRouter();
  //cast type bc we know slug will only have one value, and therefore will be type 'string' and not 'string[]'
  const slug: any = routerSlug;
  const url = `${baseUrl()}${asPath}`;

  const [numStoriesShown, setNumStoriesShown] = useState(10);

  useRecordPageView();

  return (
    <PageContainer>
      <TagPageContainer>
        <TagQuery tagId={slug}>
          {({ tag }) => (
            <>
              <NextSeo
                title={`${ApiTag.tagName(
                  tag
                )} - South Asian News & Stories | The Juggernaut`}
                twitter={{ cardType: "summary_large_image" }}
                openGraph={{
                  title: `${ApiTag.tagName(tag)}`,
                  url: url,
                  type: "website",
                  site_name: "The Juggernaut",
                }}
              />
              <div className="w-full flex items-center justify-center py-6 px-6">
                <Title className="font-bold text-3xl">
                  {ApiTag.tagName(tag)}
                </Title>
              </div>
              <div className="w-full h-px bg-gray-400 mb-6" />
              <TagStoriesQuery numStories={numStoriesShown} tagId={tag.id}>
                {({ stories, loading }) => (
                  <StoriesListContainer>
                    <StoryList stories={stories} />
                    {ApiTag.numStories(tag) > numStoriesShown && (
                      <StoriesListLoader
                        loading={loading}
                        onClickLoad={() =>
                          setNumStoriesShown(numStoriesShown + 10)
                        }
                      />
                    )}
                  </StoriesListContainer>
                )}
              </TagStoriesQuery>
            </>
          )}
        </TagQuery>
      </TagPageContainer>
      <FooterWithState />
    </PageContainer>
  );
}

export default withApollo(TagPage);
